import { AfterViewInit, Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { EnergyResourceService } from 'src/app/providers/energy-resource/energy-resource.service';
import { NotificationService } from 'src/app/service/toaster/notification.service';

declare let $: any;
@Component({
  selector: 'app-course-modal',
  templateUrl: './course-modal.component.html',
  styleUrls: ['./course-modal.component.scss']
})
export class CourseModalComponent implements OnInit, AfterViewInit {
  @Input() header;
  @Input() empId;
  @Input() courseId;
  @Input() coursesData;
  dynamicHeader;
  courseForm : FormGroup;
  submitted = false;
  loading = false;
  result: any = [];
  certFile: any;
  courses : any = [];
  crseID;
  constructor(
    private erService : EnergyResourceService,
    private notifyService : NotificationService,
  ) {
    console.log('yeh2 -> ' , this.courseId)
    this.crseID = this.courseId;
   }

  ngOnInit(): void {
    this.courseForm = new FormGroup({
      user_id : new FormControl('' , Validators.required),
      course_name : new FormControl('' , Validators.required),
      course_id : new FormControl('' , Validators.required),
      inst_name : new FormControl('' , Validators.required),
      start_date : new FormControl('' , Validators.required),
      valid_date : new FormControl('' , Validators.required),
      attachment : new FormControl('' , Validators.required),
    });
    console.log(this.crseID);
    // setTimeout(() => {
    //   console.log('yeh -> ' , this.courseId)
    //   this.courseForm.patchValue({
    //     course_name : this.courseId
    //   });
    // }, 10000);
  }

  ngAfterViewInit(): void {
    // console.log(this.crseID);
    // this.courseForm.patchValue({
    //   course_name: this.courseId
    // });
  }

  get crseErrorMsg() {return this.courseForm.controls}
  get course_name() {return this.courseForm.get('course_name').value;}

  onSubmitCourse(): void {
    console.log('emp2', this.empId);
    console.log('courseId', this.courseId);
    return
    if(this.empId == '') {
      this.notifyService.showInfo('id missing');
      return
    }
    const courseFormData = new FormData();
    courseFormData.append('course_name', this.courseForm.get('course_name').value);
    courseFormData.append('course_id', this.courseForm.get('course_id').value);
    courseFormData.append('inst_name', this.courseForm.get('inst_name').value);
    courseFormData.append('start_date', this.courseForm.get('start_date').value);
    courseFormData.append('valid_date', this.courseForm.get('valid_date').value);
    courseFormData.append('attachment', this.certFile);
    courseFormData.append('user_id', this.empId);
    // this.erService.testAddCourse(courseFormData).subscribe( res => {
    //   this.result = res;
    //   if(this.result.status){
    //     this.notifyService.showSuccess(this.result.msg);
    //   } else {
    //     this.notifyService.showError(this.result.msg);
    //   }
    // })
  }

  onFileChange(event) : void {
    if(event.target.files.length > 0) {
      const file = event.target.files[0];
      this.certFile = file;
    }
  }

  onReset(): void {
    this.courseForm.reset();
    $('#course_modal').modal('hide');
  }

}
